const feedConfig = {
  allTopicKeys: () => {
    const coreKeys = Object.keys(feedConfig.feedInfo);
    return coreKeys.map((key) => {
      if (feedConfig.feedInfo[key].topicKey) return feedConfig.feedInfo[key].topicKey;
      return key;
    });
  },
  topicKeyToCoreKey: (tk) => {
    const keys = tk.split('-');
    return keys[keys.length - 1];
  },
  feedInfoFromTopicKey: (tk) => {
    const ck = feedConfig.topicKeyToCoreKey(tk);
    return feedConfig.feedInfo[ck];
  },

  // map of coreKey to info
  // coreKey is a public facing key and defaults to topicKey.split('-').last
  // info consists of:
  //   heading, description, [relatedKeys]
  //   (optional) topicKey - if not provided then same as parent key
  feedInfo: {
    marketing: {
      heading: 'Marketing',
      description: 'Raising awareness, from organic to paid',
      relatedKeys: [
        'marketing-email',
        'marketing-positioning',
        'marketing-influencer',
        'marketing-content',
        'marketing-seo',
        'marketing-b2b',
      ],
    },
    email: {
      heading: 'Email Marketing',
      description: 'Engaging users at scale',
      topicKey: 'marketing-email',
      relatedKeys: ['marketing-positioning', 'marketing-content', 'marketing-b2b'],
    },
    positioning: {
      heading: 'Positioning',
      description: 'Setting yourself apart from the rest',
      topicKey: 'marketing-positioning',
      relatedKeys: ['marketing-content', 'marketing-b2b', 'marketing-influencer'],
    },
    influencer: {
      heading: 'Influencer Marketing',
      description: 'Becoming the cool kid',
      topicKey: 'marketing-influencer',
      relatedKeys: ['marketing-positioning'],
    },
    content: {
      heading: 'Content Marketing',
      description: 'Educating potential users',
      topicKey: 'marketing-content',
      relatedKeys: ['marketing-seo'],
    },
    seo: {
      heading: 'Search Engines (SEO)',
      description: 'Getting search engines to send you users',
      topicKey: 'marketing-seo',
      relatedKeys: ['marketing-content'],
    },
    b2b: {
      heading: 'Marketing to Business',
      description: 'Engaging businesses',
      topicKey: 'marketing-b2b',
      relatedKeys: ['startups-saas'],
    },

    sales: {
      heading: 'Sales',
      description: 'Growing customers, from inbound to outbound',
      relatedKeys: ['sales-inside', 'sales-leadership'],
    },
    inside: {
      heading: 'Inside Sales',
      description: 'Growing customers, from inbound to outbound',
      topicKey: 'sales-inside',
    },
    leadership: {
      heading: 'Sales Leadership',
      description: 'Growing customers, from inbound to outbound',
      topicKey: 'sales-leadership',
    },

    product: {
      heading: 'Product',
      description: 'Knowing what to build',
      relatedKeys: ['product-research', 'product-ux', 'product-strategy'],
    },
    research: {
      heading: 'Customer Research',
      description: 'Knowing what to build',
      topicKey: 'product-research',
      relatedKeys: ['product-ux', 'product-strategy'],
    },
    ux: {
      heading: 'User Experience',
      description: 'Knowing what to build',
      topicKey: 'product-ux',
      relatedKeys: ['product-research', 'product-strategy'],
    },
    strategy: {
      heading: 'Strategy',
      description: 'Deciding what to build',
      topicKey: 'product-strategy',
      relatedKeys: ['product-research', 'product-ux'],
    },

    startups: {
      heading: 'Startups',
      description: 'Building companies, from entrepreneurs to investors',
      relatedKeys: ['startups-saas', 'startups-fundraising'],
    },

    saas: {
      heading: 'SaaS',
      description: 'Software as a Service',
      topicKey: 'startups-saas',
      relatedKeys: ['marketing-b2b'],
    },

    fundraising: {
      heading: 'Fundraising',
      description: 'Fueling big ideas',
      topicKey: 'startups-fundraising',
      relatedKeys: ['startups'],
    },

    community: {
      heading: 'Community',
      description: 'Raising awareness, from organic to paid',
      relatedKeys: ['marketing', 'sales'],
    },
  },
};

export default feedConfig;
